/* Halden & Rowe — shared front-end behaviour. Vanilla JS, no dependencies. */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var items = document.querySelectorAll('.hr-reveal');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('hr-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hr-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (el) { observer.observe(el); });
  }

  function initGalleries() {
    document.querySelectorAll('[data-hr-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-hr-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-hr-gallery-thumb]');
      var videoPanels = gallery.querySelectorAll('[data-hr-gallery-video]');
      if (!main || !thumbs.length) return;

      function hideVideos() {
        videoPanels.forEach(function (panel) {
          panel.hidden = true;
          var player = panel.querySelector('video');
          if (player) player.pause();
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');

          var videoId = thumb.getAttribute('data-video-id');
          if (videoId) {
            hideVideos();
            main.hidden = true;
            var panel = gallery.querySelector('[data-hr-gallery-video="' + videoId + '"]');
            if (panel) panel.hidden = false;
            return;
          }

          hideVideos();
          main.hidden = false;
          var src = thumb.getAttribute('data-full');
          var alt = thumb.getAttribute('data-alt') || '';
          if (!src) return;
          main.src = src;
          main.alt = alt;
        });
      });
    });
  }

  function initBundleColors() {
    document.querySelectorAll('[data-hr-qty-offer]').forEach(function (wrap) {
      var form = wrap.closest('form');
      if (!form) return;
      var colorsWrap = form.querySelector('[data-hr-bundle-colors]');
      var dataEl = form.querySelector('[data-hr-variants-json]');
      if (!colorsWrap || !dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var qtyOptions = wrap.querySelectorAll('[data-hr-qty-offer-option]');
      var submitBtn = form.querySelector('[data-hr-submit]');

      function bundleQty() {
        var sel = wrap.querySelector('[data-hr-qty-offer-option].is-selected');
        return sel ? parseInt(sel.getAttribute('data-qty'), 10) : 1;
      }

      function updateVisibility() {
        colorsWrap.hidden = bundleQty() <= 1;
      }

      qtyOptions.forEach(function (opt) {
        opt.addEventListener('click', updateVisibility);
      });
      updateVisibility();

      colorsWrap.querySelectorAll('.hr-swatch--sm').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('[data-hr-bundle-option-index]');
          group.querySelectorAll('.hr-swatch--sm').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
        });
      });

      function findVariantForUnit(unitIndex) {
        var unitEl = colorsWrap.querySelector('[data-hr-bundle-unit="' + unitIndex + '"]');
        if (!unitEl) return null;
        var groups = unitEl.querySelectorAll('[data-hr-bundle-option-index]');
        var options = [];
        groups.forEach(function (g) {
          var idx = g.getAttribute('data-hr-bundle-option-index');
          var picked = g.querySelector('.hr-swatch--sm.is-selected');
          options[idx] = picked ? picked.getAttribute('data-value') : null;
        });
        return variants.find(function (v) {
          return v.options.every(function (val, i) { return val === options[i]; });
        });
      }

      form.addEventListener('submit', function (e) {
        var qty = bundleQty();
        if (qty <= 1) return;
        e.preventDefault();

        var items = [];
        for (var i = 0; i < qty; i++) {
          var v = findVariantForUnit(i);
          if (v) items.push({ id: v.id, quantity: 1 });
        }
        if (!items.length) return;

        if (submitBtn) submitBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function () {
            if (submitBtn) submitBtn.disabled = false;
            window.alert('Something went wrong adding the bundle to your cart. Please try again.');
          });
      });
    });
  }

  function initVariantPickers() {
    document.querySelectorAll('[data-hr-variant-picker]').forEach(function (root) {
      var dataEl = root.querySelector('[data-hr-variants-json]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = root.querySelector('[data-hr-variant-id]');
      var priceEl = root.querySelector('[data-hr-price]');
      var comparePriceEl = root.querySelector('[data-hr-compare-price]');
      var saveBadgeEl = root.querySelector('[data-hr-save-badge]');
      var submitBtn = root.querySelector('[data-hr-submit]');
      var submitText = root.querySelector('[data-hr-submit-text]');

      var addLabel = submitBtn ? submitBtn.getAttribute('data-label-add') : 'Add to Cart';
      var soldOutLabel = submitBtn ? submitBtn.getAttribute('data-label-soldout') : 'Sold Out';
      var unavailableLabel = submitBtn ? submitBtn.getAttribute('data-label-unavailable') : 'Unavailable';

      function selectedOptions() {
        var groups = root.querySelectorAll('[data-hr-option-index]');
        var options = [];
        groups.forEach(function (group) {
          var index = group.getAttribute('data-hr-option-index');
          var picked = group.querySelector('.hr-swatch.is-selected');
          options[index] = picked ? picked.getAttribute('data-value') : null;
        });
        return options;
      }

      function findVariant() {
        var options = selectedOptions();
        return variants.find(function (v) {
          return v.options.every(function (val, i) { return val === options[i]; });
        });
      }

      function money(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function updateUI() {
        var variant = findVariant();
        if (!variant) {
          if (submitBtn) { submitBtn.disabled = true; }
          if (submitText) submitText.textContent = unavailableLabel;
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = money(variant.price);
        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = money(variant.compare_at_price);
            comparePriceEl.style.display = '';
            if (saveBadgeEl) {
              var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
              saveBadgeEl.textContent = 'Save ' + pct + '%';
              saveBadgeEl.style.display = '';
            }
          } else {
            comparePriceEl.style.display = 'none';
            if (saveBadgeEl) saveBadgeEl.style.display = 'none';
          }
        }
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          if (submitText) submitText.textContent = variant.available ? addLabel : soldOutLabel;
        }
      }

      root.querySelectorAll('.hr-swatch').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('[data-hr-option-index]');
          group.querySelectorAll('.hr-swatch').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          updateUI();
        });
      });

      updateUI();
    });
  }

  function initQtyOffer() {
    document.querySelectorAll('[data-hr-qty-offer]').forEach(function (wrap) {
      var form = wrap.closest('form');
      var qtyInput = form ? form.querySelector('[data-hr-qty-input]') : null;
      var submitText = form ? form.querySelector('[data-hr-submit-text]') : null;
      var options = wrap.querySelectorAll('[data-hr-qty-offer-option]');
      options.forEach(function (opt) {
        opt.addEventListener('click', function () {
          options.forEach(function (o) { o.classList.remove('is-selected'); });
          opt.classList.add('is-selected');
          if (qtyInput) qtyInput.value = opt.getAttribute('data-qty');
          if (submitText) {
            var label = opt.getAttribute('data-btn-label');
            if (label) submitText.textContent = label;
          }
        });
      });
    });
  }

  function initAccordions() {
    document.querySelectorAll('.hr-accordion__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.hr-accordion__item');
        var panel = item.querySelector('.hr-accordion__panel');
        var isOpen = item.classList.contains('is-open');
        item.parentElement.querySelectorAll('.hr-accordion__item').forEach(function (i) {
          i.classList.remove('is-open');
          i.querySelector('.hr-accordion__panel').style.maxHeight = null;
        });
        if (!isOpen) {
          item.classList.add('is-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  }

  function initCountdowns() {
    document.querySelectorAll('[data-hr-countdown]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-end')).getTime();
      var dEl = el.querySelector('[data-unit="days"]');
      var hEl = el.querySelector('[data-unit="hours"]');
      var mEl = el.querySelector('[data-unit="minutes"]');
      var sEl = el.querySelector('[data-unit="seconds"]');

      function pad(n) { return String(n).padStart(2, '0'); }

      function tick() {
        var now = Date.now();
        var diff = Math.max(0, target - now);
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        var secs = Math.floor((diff % 60000) / 1000);
        if (dEl) dEl.textContent = pad(days);
        if (hEl) hEl.textContent = pad(hours);
        if (mEl) mEl.textContent = pad(mins);
        if (sEl) sEl.textContent = pad(secs);
        if (diff <= 0) clearInterval(timer);
      }

      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  function initCountUp() {
    var items = document.querySelectorAll('[data-hr-count-up]');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.textContent = el.getAttribute('data-hr-count-up'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var end = parseFloat(el.getAttribute('data-hr-count-up')) || 0;
        var suffix = el.getAttribute('data-suffix') || '';
        var duration = 1400;
        var start = performance.now();
        function frame(now) {
          var progress = Math.min(1, (now - start) / duration);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(end * eased) + suffix;
          if (progress < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
        observer.unobserve(el);
      });
    }, { threshold: 0.4 });
    items.forEach(function (el) { observer.observe(el); });
  }

  function initTilt() {
    if (reduceMotion || matchMedia('(pointer: coarse)').matches) return;
    document.querySelectorAll('.hr-tilt').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = 'perspective(700px) rotateX(' + (y * -4) + 'deg) rotateY(' + (x * 4) + 'deg)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  function initCarouselArrows() {
    document.querySelectorAll('[data-hr-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('.hr-carousel');
      var prev = wrap.querySelector('[data-hr-prev]');
      var next = wrap.querySelector('[data-hr-next]');
      if (!track) return;
      function scrollByCard(dir) {
        var card = track.querySelector(':scope > *');
        var amount = card ? card.getBoundingClientRect().width + 20 : 300;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
      if (next) next.addEventListener('click', function () { scrollByCard(1); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initGalleries();
    initVariantPickers();
    initQtyOffer();
    initBundleColors();
    initAccordions();
    initCountdowns();
    initCountUp();
    initTilt();
    initCarouselArrows();
  });
})();
